import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import configureStore, { persistStore } from 'store'
import Routes from 'routes'
import 'styles/global-styles'
import registerServiceWorker from 'utils/registerServiceWorker'
import * as auth from 'actions/auth'
import * as fund from 'actions/fund'
import 'font-awesome/css/font-awesome.css'

const store = configureStore()

// begin periodically persisting the store
persistStore(store)
  .then(() => store.dispatch(auth.checkAuth()))
  .then(() => store.dispatch(fund.fetchTicker()))
  .then(() => {
    // get history and refresh every 12 hours
    setInterval(
      () => store.dispatch(fund.fetchHistories()),
      12 * 60 * 60 * 1000
    )
    // reload wallet balances every 15 mins
    setInterval(
      () => store.dispatch(fund.fetchHashFundsQuantities()),
      15 * 60 * 1000
    )
  })
  .catch(error => console.error(error))

render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js